import type { Layout, LayoutItem } from 'react-grid-layout'

import type {
  WidgetInUseDto,
  WidgetSizeDto,
} from '@pages/IntroducingBroker/DashboardPoC/dashboardApi.types'

export enum WidgetType {
  REFERRAL_LINK = 'referral-links',
  PAYOUT_SCHEME = 'payout-scheme',
  QUICK_PERFORMANCE = 'quick-performance',
  LOYALTY_PROGRAM = 'loyalty-program',
  IB_WALLETS = 'ib-wallets',
  IB_TRANSACTION_HISTORY = 'ib-transaction-history',
  IB_REBATES_MANAGEMENT = 'ib-rebates-management',
  IB_CJM = 'ib-cjm',
  IB_METRICS = 'ib-metrics',
}

const WIDGET_TYPES = new Set<string>(Object.values(WidgetType))

export function isWidgetType(type: string): type is WidgetType {
  return WIDGET_TYPES.has(type)
}

export type WidgetLayout = LayoutItem

export interface DashboardGridChange {
  layout: Layout
  changedItem: WidgetLayout
  interaction: 'drag' | 'resize'
}

export interface Widget {
  id: string
  type: WidgetType
  size: WidgetSizeDto
  title: string
  layout: WidgetLayout | null
  mobileLayout: WidgetLayout | null
  inUse?: WidgetInUseDto
}

export interface TempLayout {
  name: string
  description: string
  widgets: Widget[]
  isDefault?: boolean
}

export interface LocalEdits {
  layoutId: string
  widgets: Widget[]
  name?: string
  description?: string
}

export interface DashboardLayout {
  id: string
  name: string
  description: string
  isPreset: boolean
  widgets: Widget[]
  isDefault?: boolean
}

export const MAX_CUSTOM_LAYOUTS = 10
export const LAYOUT_NAME_REGEX = /^[A-Za-z0-9 -]+$/
export const TITLE_LIMIT = 25
export const DESCRIPTION_LIMIT = 150
